import { Component, OnInit } from '@angular/core';
import {RestBackendService} from "../../service/rest-backend.service";
import {ActivatedRoute, Router} from "@angular/router";
import {ConfirmationService, MessageService} from "primeng/api";
import {GlobalService} from "../../service/global.service";
import {ConfigService} from "../../service/config.service";
import {JalaliDateCalculatorService, PersianNumberService} from "ngx-persian";
import {PageDoc} from "../../dto/PageDoc";

@Component({
  selector: 'app-link-generator',
  templateUrl: './link-generator.component.html',
  styleUrls: ['./link-generator.component.css']
})
export class LinkGeneratorComponent implements OnInit {
  private pageID: string = "";
  private postID: string = "";
  page:PageDoc = new PageDoc();
  docName:string ="";
  pageName:string ="";
  postName:string ="";

  constructor(protected restBack: RestBackendService,
              public route: Router,
              public activeRoute: ActivatedRoute,
              protected messageService: MessageService,
              protected confirmationService: ConfirmationService,
              public global: GlobalService,
              protected config: ConfigService,
              public jalaliDateCalculatorService: JalaliDateCalculatorService,
              public persianNumberService: PersianNumberService
  ) {
  }

  ngAfterViewInit() {

  }

  ngOnInit(): void {
    this.pageID = this.activeRoute.snapshot.paramMap.get("page_id") + "";
    this.postID = this.activeRoute.snapshot.paramMap.get("post_id") + "";
    this.loadNewPage();
  }

  loadNewPage(): Promise<string> {
    var observable = this.restBack.doGet("doc/page/get_page_name" +
      "?page_uid=" + this.pageID+
      (this.postID && this.postID!='null'  ? "&post_uid=" + this.postID:"")
    );
    observable.then((result: any) => {
      var status = result["status"];
      if (status == 200) {
        let map:any = result["entity"];
        this.docName = map["docName"]+"";
        this.pageName = map["pageName"]+"";
        this.postName = map["postName"]+"";
        // @ts-ignore
        this.route.navigate([this.docName.replace(" ", "_")
          + "/" + this.pageName.replace(" ", "_")],
          { fragment : (this.postName && this.postName!=''? this.postName :'')}
          );
      } else {
        this.route.navigate(['404']);
      }

    }, error => {
      this.route.navigate(['404']);
    }).finally(() => {


    });
    return observable;
  }

}
